import { DownloadFile, getUtility, Icon, PrintFile, ExpandedTooltip } from '@livable/saas-react-components';
import { Chip, Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import moment from 'moment';
import React from 'react';
import { useTranslation } from 'react-i18next';
import AllocationPreviewModal from 'src/components/statements/AllocationPreviewModal';
import { FEE_TYPES_NAME, TRANSACTION_TYPES, TRANSACTION_TYPESV2 } from 'src/constants/payments';
import { useStore } from 'src/stores';
// import { BillMenu } from 'src/pages/ResidentProfilePage/Bills/Statament/BillMenu';
import ResendStatementModal from 'src/pages/ResidentProfilePage/ResendStatementModal';
import VoidStatementModal from 'src/pages/ResidentProfilePage/VoidStatementModal';
import useStatamentStyles from './styles';

// ? i18n
const BillTable = observer(props => {
  const classes = useStatamentStyles();
  const store = useStore();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const isFinalStatement = props.isFinalStatement,
    isVoided = props.isVoided,
    propertyId = props.propertyId,
    residencyId = props.residencyId,
    setTriggerRefresh = props.setTriggerRefresh,
    statementData = props.statementData,
    userProfileData = props.userProfileData;
  const _ref = statementData || {},
    charges = _ref.charges,
    fileId = _ref.fileId,
    id = _ref.id,
    paperFileId = _ref.paperFileId,
    total = _ref.total;
  const getTitle = (sType, uType) => {
    if (sType === TRANSACTION_TYPESV2.UtilityCredit) return FEE_TYPES_NAME[sType] || TRANSACTION_TYPES[sType] + ', ' + uType;else if (sType === TRANSACTION_TYPESV2.UtilityCharge) return uType;else return FEE_TYPES_NAME[sType] || TRANSACTION_TYPES[sType];
  };
  const getBoldLineComponent = text => /*#__PURE__*/React.createElement(Typography, {
    className: classes.leftSpace,
    variant: "h5"
  }, text);
  const getLabel = s => s.isSkipped ? 'Skipped' : 'Opt Out';
  const getLightLineComponent = text => /*#__PURE__*/React.createElement(Typography, {
    className: classes.leftSpace,
    color: "light",
    variant: "h6"
  }, text);
  const getServieceDatesText = (startDate, endDate) => "".concat(t('resident_account.service_dates'), ' ').concat(moment(startDate).format('MM/DD/YYYY') + ' - ' + moment(endDate).format('MM/DD/YYYY'));
  const getSecondLine = s => {
    var _s$metadata, _s$metadata3, _s$metadata4;
    if (((_s$metadata = s.metadata) === null || _s$metadata === void 0 ? void 0 : _s$metadata.amountBeforeUtilityCap) === null && s.type === TRANSACTION_TYPESV2.UtilityCharge) {
      return getLightLineComponent(getServieceDatesText(s.metadata.serviceStartDateOnly, s.metadata.serviceEndDateOnly));
    } else if (s.type === TRANSACTION_TYPESV2.UtilityCredit) {
      var _s$metadata2;
      return getLightLineComponent(((_s$metadata2 = s.metadata) === null || _s$metadata2 === void 0 ? void 0 : _s$metadata2.reason) + ', ' + getServieceDatesText(s.metadata.serviceStartDateOnly, s.metadata.serviceEndDateOnly));
    } else if (s.startDateOnly) {
      return getLightLineComponent(getServieceDatesText(s.startDateOnly, s.endDateOnly));
    } else if ((_s$metadata3 = s.metadata) !== null && _s$metadata3 !== void 0 && _s$metadata3.paperStatementYear && (_s$metadata4 = s.metadata) !== null && _s$metadata4 !== void 0 && _s$metadata4.paperStatementMonth) {
      return getLightLineComponent("".concat(t('resident_account.statement_period'), ' ').concat(moment("".concat(s.metadata.paperStatementYear, "-").concat(s.metadata.paperStatementMonth)).format('MMMM YYYY')));
    } else if (TRANSACTION_TYPES[s.type] === TRANSACTION_TYPES.CustomCharge || TRANSACTION_TYPES[s.type] === TRANSACTION_TYPES.CustomCredit) {
      var _s$metadata5, _s$metadata6, _s$metadata7, _s$metadata8;
      return getLightLineComponent(FEE_TYPES_NAME[s === null || s === void 0 || (_s$metadata5 = s.metadata) === null || _s$metadata5 === void 0 ? void 0 : _s$metadata5.feeType] || (s === null || s === void 0 || (_s$metadata6 = s.metadata) === null || _s$metadata6 === void 0 ? void 0 : _s$metadata6.feeType) || (s === null || s === void 0 ? void 0 : s.type) && "".concat(s !== null && s !== void 0 && (_s$metadata7 = s.metadata) !== null && _s$metadata7 !== void 0 && _s$metadata7.title ? s === null || s === void 0 || (_s$metadata8 = s.metadata) === null || _s$metadata8 === void 0 ? void 0 : _s$metadata8.title : ''));
    } else if (TRANSACTION_TYPES[s.type] === TRANSACTION_TYPES.Void) {
      var _s$metadata9;
      const voidedData = store.statement.voidedTransactionData((_s$metadata9 = s.metadata) === null || _s$metadata9 === void 0 ? void 0 : _s$metadata9.voidedTransactionId);
      if (voidedData !== null && voidedData !== void 0 && voidedData.metadata.feeType) {
        return getLightLineComponent(FEE_TYPES_NAME[voidedData === null || voidedData === void 0 ? void 0 : voidedData.metadata.feeType]);
      } else if ((voidedData === null || voidedData === void 0 ? void 0 : voidedData.transactionType) === TRANSACTION_TYPESV2.UtilityCharge) {
        var _store$utilityProvide;
        const utilityData = getUtility((_store$utilityProvide = store.utilityProviders.utilities.get(voidedData.metadata.utilityId)) === null || _store$utilityProvide === void 0 ? void 0 : _store$utilityProvide.utilityTypeName);
        return /*#__PURE__*/React.createElement(React.Fragment, null, getBoldLineComponent(TRANSACTION_TYPESV2.UtilityCharge + ": ".concat(utilityData.title)), getLightLineComponent(getServieceDatesText(s.startDate, s.endDate)));
      } else if (voidedData !== null && voidedData !== void 0 && voidedData.transactionType) {
        let data = (voidedData === null || voidedData === void 0 ? void 0 : voidedData.metadata.title) || (voidedData === null || voidedData === void 0 ? void 0 : voidedData.metadata.reason);
        data = data ? ': ' + data : '';
        return getLightLineComponent(TRANSACTION_TYPES[voidedData === null || voidedData === void 0 ? void 0 : voidedData.transactionType] + data);
      }
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classes.billTable
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.headerTable
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, isFinalStatement ? 'Final' : 'Regular', " statement", isVoided ? /*#__PURE__*/React.createElement(Chip, {
    className: classes.chip,
    label: "Voided",
    size: "small",
    variant: "inactive"
  }) : null), /*#__PURE__*/React.createElement("div", {
    className: classes.actionsButtons
  }, /*#__PURE__*/React.createElement(DownloadFile, {
    disabled: !fileId,
    fileId: fileId,
    usePreSignedDownload: store.account.featureFlagsStore.getIsPresignedFileFeatureEnabled,
    size: "small",
    store: store,
    text: "Download",
    variant: "actionButton"
  }), /*#__PURE__*/React.createElement(PrintFile, {
    disabled: !fileId,
    fileId: fileId,
    getUrlAsyncCallback: async () => {
      const resp = await store.files.getPresignedFileDownloadUrlAsync.run({
        fileId: fileId,
        isPreview: true
      });
      if (resp !== null && resp !== void 0 && resp.isSuccessful) {
        return resp.response;
      }
    },
    href: store.account.featureFlagsStore.getIsPresignedFileFeatureEnabled ? null : "".concat(store.files.getFilePreviewLink({
      fileId: fileId
    })),
    size: "small",
    text: "general.print",
    variant: "actionButton"
  }), !store.company.companyFeatureStore.disableVoidStatement && /*#__PURE__*/React.createElement("div", {
    className: classes.actionsButton
  }, /*#__PURE__*/React.createElement(VoidStatementModal, {
    disabled: isVoided,
    id: id,
    setTriggerRefresh: setTriggerRefresh,
    variant: "actionButton"
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.actionsButton
  }, /*#__PURE__*/React.createElement(ResendStatementModal, {
    residencyId: residencyId,
    userProfileData: userProfileData,
    resendStatementId: id,
    resendStatementFileId: paperFileId,
    variant: "actionButton"
  })))), charges === null || charges === void 0 ? void 0 : charges.map(s => {
    var _s$metadata0, _store$utilityProvide2, _s$metadata1, _s$metadata10;
    const uId = s.utilityId || ((_s$metadata0 = s.metadata) === null || _s$metadata0 === void 0 ? void 0 : _s$metadata0.utilityId);
    const utilityData = getUtility((_store$utilityProvide2 = store.utilityProviders.utilities.get(uId)) === null || _store$utilityProvide2 === void 0 ? void 0 : _store$utilityProvide2.utilityTypeName);
    return /*#__PURE__*/React.createElement("div", {
      className: "".concat(classes.bodyTable, " ").concat(isVoided ? classes.disabled : '')
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.utility
    }, /*#__PURE__*/React.createElement("div", {
      className: "".concat(classes.utilityInfo, " ").concat(s.isSkipped ? classes.disabled : '')
    }, s.metadata.utilityId ? utilityData.icon() : /*#__PURE__*/React.createElement(Icon, {
      type: "coins-in-hand"
    }), /*#__PURE__*/React.createElement("div", {
      className: classes.utilityText
    }, getBoldLineComponent(getTitle(s.type, utilityData.title)), getSecondLine(s))), /*#__PURE__*/React.createElement("div", {
      className: classes.flexWrapper
    }, s !== null && s !== void 0 && (_s$metadata1 = s.metadata) !== null && _s$metadata1 !== void 0 && _s$metadata1.amountBeforeUtilityCap ? /*#__PURE__*/React.createElement("div", {
      className: classes.utilityCap
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "h5"
    }, /*#__PURE__*/React.createElement("s", null, "$", s === null || s === void 0 || (_s$metadata10 = s.metadata) === null || _s$metadata10 === void 0 ? void 0 : _s$metadata10.amountBeforeUtilityCap)), /*#__PURE__*/React.createElement(ExpandedTooltip, {
      title: "Utility cap is applied",
      placement: "top",
      type: "info"
    }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Icon, {
      type: "question",
      state: "info"
    })))) : '', /*#__PURE__*/React.createElement(Typography, {
      variant: "h5"
    }, s.isSkipped || s.isOptOut ? /*#__PURE__*/React.createElement(Chip, {
      label: getLabel(s),
      size: "small",
      variant: "inactive"
    }) : "".concat(s.isCredit ? '-' : '', "$").concat(s.amount)))), /*#__PURE__*/React.createElement("div", {
      className: classes.allocationButton
    }, /*#__PURE__*/React.createElement("div", null, !s.isSkipped && s.type === TRANSACTION_TYPESV2.UtilityCharge && s.billingCycleId ? /*#__PURE__*/React.createElement(AllocationPreviewModal, {
      billingCycleId: s.billingCycleId,
      propertyId: propertyId,
      triggerType: "actionButton",
      utility: {
        utilityId: s.utilityId,
        utilityTypeName: utilityData.title
      }
    }) : null)));
  }), total >= 0 && /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.bodyTable, " ").concat(isVoided ? classes.disabled : '')
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.utility
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, "Total"), /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    className: classes.leftSpace
  }, "$", total)), /*#__PURE__*/React.createElement("div", {
    className: classes.allocationButton
  })));
});
export default BillTable;